import React, { useContext } from 'react';

import DashboardGadgetContext from '../../contexts/DashboardGadgetContext';
import GqlClientProvider from '../../contextProviders/SplashScreenProviders/UserAndAccountProviders/GqlClientProvider';
import CanvasCard from '../Visualisations/CanvasCard';
import DashboardGadgetBottomBar from '../DashboardGadgetBottomBar';
import GroupVsRemainderContent from './GroupVsRemainderContent';
import FlexCentered from '../Common/FlexCentered';
import { TopBar } from './TopBar';
import { GroupVsRemainderProvider } from './GroupVsRemainderProvider';

const GroupVsRemainder = ({
  gadget,
}: {
  gadget: VisualisationDefinitions.GroupVsRemainder;
}) => {
  const { dashboardGadget } = useContext(DashboardGadgetContext);

  return (
    <FlexCentered style={{ height: '100%', width: '100%' }}>
      <GroupVsRemainderProvider>
        <CanvasCard
          isContentWithoutPadding
          topBar={<TopBar chartDefinition={gadget} title={gadget.name} />}
          bottomBar={dashboardGadget ? <DashboardGadgetBottomBar /> : undefined}
          content={
            <GqlClientProvider
              visName={gadget.name}
              visId={gadget.id}
              visType={gadget.type}
            >
              <GroupVsRemainderContent gadget={gadget} />
            </GqlClientProvider>
          }
        />
      </GroupVsRemainderProvider>
    </FlexCentered>
  );
};

export default GroupVsRemainder;
